<template>
  <div class="hello">
    <div class="share">
      <el-main>
        <div style="display: flex;justify-content: flex-end;">
          <el-button type="primary" @click="loadPdf" :loading="PdfType">导出</el-button>
        </div>
        <div class="box">
          <div class="itemBox" ref="pdfBox">
            <!-- <div class="signinBox" ref="imgSignin">
              <el-image style="height: 692px;width: 1000px;" fit="contain" :src="signin"></el-image>
              <div class="title">{{ info.title }} </div>
              <el-image class="signin" fit="contain" :src="info.sign_in_qr_code"></el-image>
            </div> -->

            <div class="question" v-for="(item, index) in info.signup">
              <div class="signinBoxTwo" :ref="'img' + item.id" v-if="item">
                <el-image style="height: 692px;width: 1000px;" fit="contain" :src="fileImg"></el-image>
                <div class="title">{{ info.title }} </div>
                <div class="name">{{ item.name }} </div>
                <img crossorigin="anonymous" class="signin" :src="item.qr_code" />
              </div>
              <div v-else class="signinBoxTwo" :ref="'img' + item.id">

              </div>
            </div>
          </div>
        </div>
      </el-main>
    </div>
  </div>
</template>

<script>
import { htmlPdf } from "@/utils/pdfCS.js";
import axios from 'axios'
import fileImg from "@/assets/rcz.jpg";
import signin from "@/assets/signin.jpg";
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      fileImg,
      signin,
      PdfType: false,
      info: {}
    }
  },
  mounted() {
    console.log(this.$route.query);
    axios({
      method: "POST",
      url: "https://eventadmin.hytera.com/api/v1/getSignInImages",
      headers: {
        'Content-Type': 'application/json;charset=UTF-8;',
        'Authorization': 'Bearer YOUR_ACCESS_TOKEN',
      },
      data: {
        salt: this.$route.query.salt,
      }

    }).then(response => {
      console.log(response.data.data);
      this.info = response.data.data

      // this.info.signup.length 长度为奇数的时候添加一个参数
      if (this.info.signup.length % 2 !== 0) {
        this.info.signup.push({
          id: 0
        })
      }
      console.log(this.info.signup, "this.info.signup");
    });
  },
  methods: {
    async loadPdf() {
      this.PdfType = true;
      // await htmlPdf("分析板块报告", this.$refs.pdfBox);
      console.log(this.$refs);
      let imgElements = [];
      // imgElements.push(this.$refs['imgSignin']);
      // 遍历数组并将每个元素的引用添加到 imgElements 数组
      this.info.signup.forEach((item, index) => {
        imgElements.push(this.$refs['img' + item.id][0]);
      })
      console.log(imgElements);
      await htmlPdf("分析板块报告", imgElements);
      this.PdfType = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@font-face {
  font-family: 'MyriadPro-Semibold';
  /* 自定义字体名称 */
  src: url('@/assets/MyriadPro-Semibold.otf') format('opentype');
  /* 指向你的OTF字体文件的路径 */
  font-weight: normal;
  font-style: normal;
}

.share {
  .box {
    display: flex;
    justify-content: center;

    .itemBox {
      width: 1000px;

      .signinBox {
        height: 692px;
        position: relative;

        .title {
          font-family: 'MyriadPro-Semibold', sans-serif;
          /* 使用你定义的字体名称 */
          position: absolute;
          top: 118px;
          right: 50%;
          color: #fff;
          transform: translate(50%, 0%);
          font-size: 18px;
        }

        .signin {
          height: 170px;
          width: 170px;
          position: absolute;
          top: 49%;
          right: 50%;
          transform: translate(50%, -50%);
        }
      }

      .signinBoxTwo {
        height: 692px;
        position: relative;

        .title {
          font-family: "MyriadPro-Semibold", sans-serif;
          position: absolute;
          top: 128px;
          right: 74%;
          color: #fff;
          transform: translate(50%, 0%);
          font-size: 18px;
        }

        .name {
          font-family: "MyriadPro-Semibold", sans-serif;
          position: absolute;
          top: 487px;
          left: 31px;
          transform: translate(0%, -50%);
          width: 452px;
          color: #fff;
          font-size: 22px;
          text-align: center;
        }

        .signin {
          height: 170px;
          width: 170px;
          position: absolute;
          top: 361px;
          left: 88px;
          transform: translate(50%, -50%);
        }
      }
    }
  }
}
</style>
